import React from 'react';
import { useDownloadUsers } from '../../hooks/useDownloadUsers';

const DownloadUsersButton = () => {
  const { downloadUsers, isLoading } = useDownloadUsers();

  return (
    <button
      onClick={downloadUsers}
      disabled={isLoading}
      className={`flex text-gray-800 dark:text-white hover:text-blue-500 items-center my-4`}
    >
      {isLoading ? 'Downloading...' : 'Download users'}
    </button>
  );
};

export default DownloadUsersButton;
